import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

import { contractsSelectorKey, reducers } from './get-contract-groups';

@NgModule({
  imports: [StoreModule.forFeature(contractsSelectorKey, reducers)],
})
export class ContractingEntityTemporaryLibraryModule {}
